:host {
    display: block;
    position: relative;
    opacity: 0;
    transition: opacity 500ms ease;
    z-index: 0;
}

:host([active]) {
    opacity: 1;
    z-index: 1;
}

::slotted(sew-ws-image-text),
::slotted(sew-ws-table) {
    margin: 60px 0;
}
::slotted(sew-ws-richtext),
::slotted(sew-ws-linklist),
::slotted(sew-ws-teaser) {
    margin: 40px 0;
}

::slotted(sew-ws-richtext) {
    width: 66%;
}

@include mq-2 {
    ::slotted(sew-ws-image-text),
    ::slotted(sew-ws-table) {
        margin: 40px 0;
    }
    ::slotted(sew-ws-richtext),
    ::slotted(sew-ws-linklist),
    ::slotted(sew-ws-teaser) {
        margin: 32px 0;
        width: auto;
    }
}

.print-headline {
    display: none;
}

@media print {
    .print-headline {
        @include typo-ws-h4;

        display: block;
        border-bottom: 5px solid $color-grey-01-dark;
        padding-bottom: 12px;
        margin: 0;
        page-break-after: avoid;
    }

    :host {
        height: auto;
    }
}
